import { IMPORT_REWARD_COUNTER } from '../constants';

export default (state = {}, { type, payload }) => {
  if (type === IMPORT_REWARD_COUNTER) {
    return payload;
  }
  return state;
};
